module.exports = __webpack_public_path__ + "static/media/logo-fresenius-img.7ffd5527.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-fresenius-img.png
// module id = 569
// module chunks = 0